export class UpdateCompanyStatusRequest {
    constructor(CompanyId, Status) {
      this.CompanyId = CompanyId;
      this.Status = Status;
    }
  }